import { Button, Form, Input, message, Modal, Radio, Select } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { RadioChangeEvent } from 'antd/lib/radio';
import gql from 'graphql-tag';
import React, { Component } from 'react';
import { Mutation } from 'react-apollo';

import { USER_CONTACT_RECORDS_QUERY } from './constants';
import { UserContactRecordIntent, UserContactRecordType } from './type';
import {
  USER_CONTACT_RECORD_FEEDBACK_LIST,
  USER_CONTACT_RECORD_INTENT_NAME,
  USER_CONTACT_RECORD_STAGE_LIST,
  UserContactRecordFeedback,
  UserContactRecordStage,
} from './Users';

interface State {
  isShowModal: boolean;
  isSuccess?: boolean;
  intent?: UserContactRecordIntent;
  feedback?: UserContactRecordFeedback;
  remark: string;
  currentStage: UserContactRecordStage;
}

interface Props {
  type: UserContactRecordType;
  userId: string;
  form: WrappedFormUtils;
}

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 5 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
  },
};

const CREATE_USER_CONTACT_RECORD_MUTATION = gql`
  mutation createUserContactRecord(
    $userId: ID!
    $type: Int!
    $intent: Int!
    $feedback: Int!
    $remark: String!
    $isSuccess: Boolean
  ) {
    createUserContactRecord(
      userId: $userId
      type: $type
      isSuccess: $isSuccess
      intent: $intent
      feedback: $feedback
      remark: $remark
    ) {
      id
    }
  }
`;

export class AddContactRecord extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShowModal: false,
      remark: '',
      currentStage: UserContactRecordStage.ALL_STAGES,
    };
  }

  hideModal = () => {
    this.setState({ isShowModal: false });
  };

  showModal = () => {
    this.setState({ isShowModal: true });
  };

  render() {
    const { type, userId } = this.props;
    const { getFieldDecorator } = this.props.form;
    const { isSuccess, intent, feedback, currentStage, remark, isShowModal } = this.state;

    const ids = [Number(userId)];
    return (
      <div>
        <Button icon="plus" onClick={this.showModal}>
          {type === UserContactRecordType.WECHAT ? '新增微信跟进' : '新增电话跟进'}
        </Button>
        <Mutation
          mutation={CREATE_USER_CONTACT_RECORD_MUTATION}
          variables={{ type, isSuccess, intent, feedback, remark, userId }}
          refetchQueries={[{ query: USER_CONTACT_RECORDS_QUERY, variables: { ids } }]}
        >
          {(createUserRolePermission, { loading }) => {
            return (
              <Modal
                title={type === UserContactRecordType.WECHAT ? '新增微信跟进' : '新增电话跟进'}
                visible={isShowModal}
                confirmLoading={loading}
                onOk={() => {
                  this.props.form.validateFields(async (err, values) => {
                    if (err) {
                      message.error(err);
                      return;
                    }
                    try {
                      let isPhoneSuccess = isSuccess;
                      if (values.isSuccess) {
                        isPhoneSuccess = values.isSuccess;
                      }
                      if (
                        (type === UserContactRecordType.PHONE_CALL && isPhoneSuccess === undefined) ||
                        values.intent === undefined ||
                        values.feedback === undefined ||
                        values.remark === ''
                      ) {
                        message.error('信息请填写完整！');
                        return;
                      }

                      this.setState(
                        {
                          isSuccess: isPhoneSuccess,
                          intent: values.intent,
                          feedback: values.feedback,
                          remark: values.remark,
                          isShowModal: false,
                        },
                        async () => {
                          await createUserRolePermission();
                          message.success('生成成功');
                        },
                      );

                      message.success('添加成功！');
                    } catch {
                      message.error('添加失败！');
                    }
                  });
                }}
                onCancel={this.hideModal}
              >
                <Form>
                  {type === UserContactRecordType.PHONE_CALL && (
                    <Form.Item label="接通情况" {...formItemLayout}>
                      {getFieldDecorator('isSuccess', {
                        rules: [
                          {
                            required: true,
                            message: '请选择接通情况',
                          },
                        ],
                      })(
                        <Radio.Group>
                          <Radio value>接通</Radio>
                          <Radio value={false}>未接通</Radio>
                        </Radio.Group>,
                      )}
                    </Form.Item>
                  )}
                  <Form.Item {...formItemLayout} label="意向度">
                    {getFieldDecorator('intent', {
                      rules: [
                        {
                          required: true,
                          message: '请选择意向度',
                        },
                      ],
                    })(
                      <Radio.Group>
                        <Radio value={UserContactRecordIntent.VERY_POSITIVE}>
                          {USER_CONTACT_RECORD_INTENT_NAME[UserContactRecordIntent.VERY_POSITIVE]}
                        </Radio>
                        <Radio value={UserContactRecordIntent.POSITIVE}>
                          {USER_CONTACT_RECORD_INTENT_NAME[UserContactRecordIntent.POSITIVE]}
                        </Radio>
                        <Radio value={UserContactRecordIntent.NEGATIVE}>
                          {USER_CONTACT_RECORD_INTENT_NAME[UserContactRecordIntent.NEGATIVE]}
                        </Radio>
                        <Radio value={UserContactRecordIntent.NO_RESPONSE}>
                          {USER_CONTACT_RECORD_INTENT_NAME[UserContactRecordIntent.NO_RESPONSE]}
                        </Radio>
                      </Radio.Group>,
                    )}
                  </Form.Item>
                  <Form.Item {...formItemLayout} label="用户反馈">
                    {getFieldDecorator('currentStage', {
                      rules: [
                        {
                          required: true,
                          message: '请选择阶段',
                        },
                      ],
                    })(
                      <Select style={{ width: '100%' }} placeholder="请选择">
                        {Object.keys(USER_CONTACT_RECORD_STAGE_LIST).map(stage => {
                          {
                            return (
                              <Select.Option key={stage} value={stage}>
                                {USER_CONTACT_RECORD_STAGE_LIST[stage]}
                              </Select.Option>
                            );
                          }
                        })}
                      </Select>,
                    )}
                    {getFieldDecorator('feedback', {
                      rules: [
                        {
                          required: true,
                          message: '请选择用户反馈',
                        },
                      ],
                    })(
                      <Select style={{ width: '100%' }} placeholder="请选择">
                        {Object.keys(USER_CONTACT_RECORD_FEEDBACK_LIST[currentStage]).map(status => {
                          {
                            return (
                              <Select.Option key={status} value={status}>
                                {USER_CONTACT_RECORD_FEEDBACK_LIST[currentStage][status]}
                              </Select.Option>
                            );
                          }
                        })}
                      </Select>,
                    )}
                  </Form.Item>
                  <Form.Item {...formItemLayout} label="跟进记录">
                    {getFieldDecorator('remark', {
                      rules: [
                        {
                          required: true,
                          message: '请输入跟进记录',
                        },
                      ],
                    })(<Input.TextArea rows={4} placeholder="请输入跟进记录详情" />)}
                  </Form.Item>
                </Form>
              </Modal>
            );
          }}
        </Mutation>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/user/AddContactRecord.tsx